import { useState, useEffect } from 'react';
import { useEnhancedCompany } from '../contexts/EnhancedCompanyContext';
import { getCompanyCurrency } from '../utils/currencyUtils';

export const useCompanyCurrency = () => {
  const { currentCompany, companyInfo, activeCompanyProfile } = useEnhancedCompany();
  const [currency, setCurrency] = useState('INR');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const profile = activeCompanyProfile || companyInfo || currentCompany;
    const liveCurrency =
      profile?.defaultCurrency ||
      profile?.currency ||
      profile?.basicInfo?.currency ||
      profile?.preferences?.defaultCurrency;

    if (liveCurrency) {
      setCurrency(liveCurrency);
      setLoading(false);
      return;
    }

    const loadCurrency = async () => {
      const companyId = currentCompany?.companyId || currentCompany?.id;
      if (companyId) {
        setLoading(true);
        try {
          const companyCurrency = await getCompanyCurrency(companyId);
          setCurrency(companyCurrency);
        } catch (error) {
          console.error('Error loading company currency:', error);
          setCurrency('INR');
        } finally {
          setLoading(false);
        }
      } else {
        setCurrency('INR');
        setLoading(false);
      }
    };

    loadCurrency();
  }, [
    currentCompany?.companyId,
    currentCompany?.id,
    companyInfo?.currency,
    companyInfo?.defaultCurrency,
    activeCompanyProfile?.currency,
    activeCompanyProfile?.defaultCurrency,
  ]);

  return { currency, loading };
};
